import { defineAsyncComponent } from 'vue';

export const TableFilterInputerHistory = defineAsyncComponent(() => import('./TableFilterInputerHistory.vue'));
export const TableTopInputerHistory = defineAsyncComponent(() => import('./TableTopInputerHistory.vue'));